<template>
  <div>
    <div class="header">
      카테고리
    </div>
    <category-inline-form
      v-for="category in parentMembershipCategories"
      :key="category.id"
      :id="category.id"
      :name="category.name"
      :is-active="category.id === activeCategoryId"
      @select="onSelectCategory"
      @delete="onDeleteCategory"
    />
    <category-inline-form
      v-if="creatingFormVisible"
      :isCreating="true"
      @closeCreateForm="setCreatingFormInvisible"
    />
    <div
      class="category-item add"
      @click="setCreatingFormVisible">
      <img
        class="folder-icon"
        src="/image/folder/add.png">
      <span>카테고리 추가</span>
    </div>
  </div>
</template>

<script>
import CategoryInlineForm from "./CategoryInlineForm";
import {computedGetters} from "../../../../utils/vuex-helper";
import { INLINE_FORM_MODE } from "../../../../constants";

export default {
	name: "CategoryList",
	components: { CategoryInlineForm },
	data() {
		return {
			INLINE_FORM_MODE,
			creatingFormVisible: false,
			categories: [],
      activeCategoryId: null
		};
	},
  computed: {
    ...computedGetters(['parentMembershipCategories'])
  },
  async created() {
		await this.$store.dispatch("syncParentMembershipCategories");
		this.onSelectCategory(this.parentMembershipCategories[0].id);
	},
	methods: {
    setCreatingFormInvisible() {
		  this.creatingFormVisible = false
    },
    setCreatingFormVisible() {
      this.creatingFormVisible = true
    },
		onSelectCategory(categoryId) {
		  this.activeCategoryId = categoryId;
      const selectedCategory = this.parentMembershipCategories
        .find(category => category.id === categoryId)
		  this.$emit("change", selectedCategory);
		},
    async onDeleteCategory() {
      await this.$store.dispatch("syncParentMembershipCategories");
      this.onSelectCategory(this.parentMembershipCategories[0].id);
    }
	},
};
</script>

<style lang="scss">
.category-item {
	height: 40px;
	border-radius: 6px;
	padding: 10px 10px 10px 40px;
	box-sizing: border-box;
	margin-bottom: 2px;
	position: relative;
	color: #4a4a4a;
	display: flex;

	&.add {
		margin-top: 20px;

		span {
			color: #9b9b9b;
		}
	}

	&.view:hover,
	&.add:hover {
		background-color: #f0f0f0;
		cursor: pointer;
	}

	&.active {
		background-color: #9b9b9b;
		color: #ffffff;

		&:hover {
			background-color: #919191;
			cursor: pointer;
		}
	}

	input {
		flex: 1;
		height: 20px;
		font-size: 14px;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.43;
		letter-spacing: -0.8px;
		background-color: transparent;
		border: 0;

		@media screen and (max-width: 768px) {
			width: calc(100% - 70px);
		}
	}

	input::placeholder {
		color: #d3d3d3;
	}

	input:focus {
		outline: none;
	}

	.folder-icon {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 30px;
	}

	span {
		display: inline-block;
		line-height: 20px;
		font-size: 14px;
		font-weight: normal;
		letter-spacing: -0.8px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		flex: 1;
	}
}
</style>
